import { EditorState, RichUtils } from 'draft-js';

const UNLISTABLE = new Set(['ordered-list-item', 'unordered-list-item', 'blockquote']);

/**
 * Backspace at the very start of the first line, when that line is a list item or a quote: the state with its
 * formatting taken off, or null to leave the key to draft-js. Draft-js only joins a line to the one above, and the
 * first line has none, so its "1." could not be removed without the toolbar button - every later item could.
 */
export const unformatFirstLine = (editorState: EditorState): EditorState | null => {
  const selection = editorState.getSelection();
  const content = editorState.getCurrentContent();
  const first = content.getFirstBlock();
  if (!selection.isCollapsed() || selection.getAnchorOffset() !== 0 || selection.getAnchorKey() !== first.getKey()) return null;
  if (!UNLISTABLE.has(first.getType())) return null;
  const unstyled = RichUtils.tryToRemoveBlockStyle(editorState);
  return unstyled ? EditorState.push(editorState, unstyled, 'change-block-type') : null;
};
